import { defineMessages } from "react-intl";

import CheckBoxField from "./CheckBoxField";
import { useFormField } from "../withFormStore";
import { useFormatMessage } from "../../Intl/Context";

// The CNIL requires consent to be tracked to be given separately from consent to receive
// emails, so this checkbox is shown on every surface creating or editing a viewer,
// independently of the platform's own email consent setting.
//
const EmailTrackingConsentField = ({ defaultChecked }) => {
  const t = useFormatMessage();
  const label = t(intlMessages.label);
  const emailConsentField = useFormField("emailConsent");

  // Being measured only matters to someone who receives newsletters : either they
  // accepted them, or the platform offers no choice and the field is never rendered.
  const receivesNewsletters =
    emailConsentField.checked === undefined || emailConsentField.checked;

  if (!receivesNewsletters) return null;

  return (
    <CheckBoxField
      fieldName="emailTrackingConsent"
      label={label}
      defaultChecked={defaultChecked}
    />
  );
};

export default EmailTrackingConsentField;

export const intlMessages = defineMessages({
  label: {
    id: "consents.emailTracking.label",
    defaultMessage: `
      J’accepte la mesure de mes ouvertures et clics dans ces e-mails pour aider l’équipe 
      du projet à en évaluer la pertinence.
    `
  }
});
